var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M7 13v2h14.5a.5.5 0 1 1 0 1H20v4h.5a.5.5 0 1 1 0 1h-17a.5.5 0 1 1 0-1H4v-4H2.5a.5.5 0 1 1 0-1H6v-2.064c-1.27-.182-2-.767-2-1.936 0-1.452.55-2.822 2-5 .44-.137 1.057.003 1 0 1.45 2.178 2 3.548 2 5 0 1.448-1.12 2-2 2zm9-8.97C14.432 4.22 13 5.3 13 7v3h7V7c0-1.701-1.432-2.78-3-2.97V10h-1V4.03zM16 16h-2v4h2v-4zm1 0v4h2v-4h-2zM5 16v4h2v-4H5zm3 0v4h2v-4H8zm3 0v4h2v-4h-2zm5.5-13C19 3 21 4.567 21 7v4h-9V7c0-2.433 2-4 4.5-4zM7 12c.587 0 1-.337 1-1 0-.822-.5-2.156-1.5-4-1 1.844-1.5 3.178-1.5 4 0 .663.413 1 2 1z" })
  );
});